
import Vue from 'vue';
import Header from '~/components/layouts/Header.vue';
import MainLayout from '~/components/layouts/mainlayout/MainLayout.vue';
import ProfileModule from '~/components/smart/ProfileModule/ProfileModule.vue';
import WidgetModule from '~/components/smart/WidgetModule.vue';

import CV from './components/CV.vue';

export default Vue.extend({
    name: 'Documents',
    components: {
        Header,
        CV,
        MainLayout,
        ProfileModule,
        WidgetModule,
    },
});
